import React from 'react';

import cn from 'classnames';

import { Input } from '@shared/ui';

import cls from './SingleForm.module.css';

interface SingleFormProps {
    classes?: string;
    onUserId: (name: string, value: string) => void;
    userIdValue: string;
}

export const SingleForm = ({ classes, onUserId, userIdValue }: SingleFormProps) => (
    <div className={cn(cls.SingleForm, [classes])}>
        <Input value={userIdValue} onValueChange={onUserId} placeholder="ID пользователя" />
    </div>
);
